import dagreLayout from './layout'

export default {
  layout: dagreLayout
}

